import React from 'react';
import SAFHeader from '../Inc/SAFHeader';
import SAFFooter from '../Inc/SAFFooter';
import './style.css';
import moment from 'moment'
import * as actions from '../../actions/index';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Iframe from '../HOC/iframe'
import MembershipAlumniInfo from '../Inc/MembershipAlumniInfo'
import { Steps, Button, Spin, Row, Col, Card, Form, Input, DatePicker, Radio, Select, Icon, Modal } from 'antd';
const FormItem = Form.Item;
const Step = Steps.Step;
const RadioGroup = Radio.Group;
const LoadingIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const CHASE_URL = process.env.REACT_APP_CHASE
let BackBtn = false
const SAF_MID = process.env.REACT_APP_SAF_MID;
class SAFSupportForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            current: 0,
            value: 1,
            creditcardChecked: false,
            TotalAmount: 0,
            SelectedMembership: '',
            SelectedMembershipName: '',
            SelectedMembershipPrice: 0,
            RushShipping: false,
            FirstName: '',
            LastName: '',
            showpaymentButton: false,
            Address: '',
            EagleInfo: '',
            ethnic: '',
            hideNext: true,
            receipt_loading: false
        };
        this.ethnicities = this.ethnicities.bind(this)
        window.showReceiptComponent = this
    }



    ChangeAmount = (e) => {
        let TotalAmount = 0;
        this.setState({
            SelectedMembership: e.target.value,
            TotalAmount: e.target.price,
            SelectedMembershipName: e.target.membership,
            SelectedMembershipPrice: e.target.price,
            showpaymentButton: true
        });
    }

    next() {
        const current = this.state.current + 1;
        this.setState({ current });
    }

    payment = () => {
        BackBtn = false;
        this.props.actions.SAFRegistration(this.props.profileinfo, this.state.SelectedMembership, this.state.SelectedMembershipPrice, this.state.EagleInfo, this.state.SelectedMembershipPrice, "SAF", SAF_MID);
    }

    prev() {
        BackBtn = true;
        const current = this.state.current - 1;
        this.setState({ current });
    }


    renderIframe = () => {
        if (this.props.initloading == true) {
            return <Row>
                <Col span={24}>
                    <Spin indicator={LoadingIcon} className="loading-state" tip="Loading Chase Payments..." />
                </Col>
            </Row>
        }
        if (this.props.initTransaction) {
            return <Row className="chase-payment">
                <Col span={24}>
                    <Iframe src={`${CHASE_URL}` + this.props.initTransaction.uID} height="700px" width="100%" />
                </Col>
            </Row>
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.next()
                let person_ethnic = values.ethnic_background
                let ethnicitiesArray = this.props.ethnicities
                ethnicitiesArray.map((k, index) => {
                    if (k.name == person_ethnic) {
                        values.ethnic_background = k.id
                        if (this.state.ethnic == '') {
                            this.setState({
                                ethnic: k.id
                            })
                        }
                    }
                })
                this.setState({
                    EagleInfo: values
                })
            }
        });
    }

    showReceipt = () => {
        console.log('show receipt');
        this.setState({
            current: 3
        })
    }

    showLoadingReceipt = () =>{
        this.setState({
            receipt_loading: true
        })
    }

    ethnicities = () => {
        if (this.props.ethnicities) {
            let ethnicitiesArray = this.props.ethnicities
            return ethnicitiesArray.map((k, index) => {
                return (
                    <option key={index} value={k.name}>{k.name}</option>
                )
            })
        }
    }

    setName = (firstname, lastname) => {
        this.setState({
            FirstName: firstname,
            LastName: lastname
        })
    }

    setAddress = (address) => {
        this.setState({
            Address: address
        })
    }

    changeEthinicity = (e) => {
        this.setState({
            ethnic: e
        })
    }

    personalInfo = () => {
        if (this.props.profileinfo) {
            if (this.state.FirstName == '')
                this.setName(this.props.profileinfo.profile.firstName, this.props.profileinfo.profile.lastName)
            const { getFieldDecorator } = this.props.form;
            let profileInfo = this.props.profileinfo
            let personemail = this.props.profileinfo.emails.filter((data) => JSON.parse(data.isPrimary.toLowerCase()))[0]
            let email = personemail.email
            let address = this.props.profileinfo.addresses.filter((data) => JSON.parse(data.isPrimary.toLowerCase()))[0]
            if (this.state.Address == '') {
                this.setAddress(address)
            }
            let personethnicity = this.props.profileinfo.extendedProfile.filter((data) => data.attributeId == "1")[0]
            return <Row gutter={48}>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <FormItem
                        label="First Name"
                    >
                        {getFieldDecorator('first_name', {
                            initialValue: profileInfo.profile.firstName,
                            rules: [{ required: false, message: 'Enter your First Name!' }],
                        })(
                            <Input placeholder="First Name" disabled />
                        )}
                    </FormItem>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <FormItem
                        label="Last Name"
                    >
                        {getFieldDecorator('last_name', {
                            initialValue: profileInfo.profile.lastName,
                            rules: [{ required: false, message: 'Enter your Last Name!' }],
                        })(
                            <Input placeholder="Last Name" disabled />
                        )}
                    </FormItem>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <FormItem
                        label="Email"
                    >
                        {getFieldDecorator('email', {
                            initialValue: email,
                            rules: [{ required: false, message: 'Enter your Email!' }],
                        })(
                            <Input placeholder="Email" disabled />
                        )}
                    </FormItem>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <FormItem
                        label="Ethnic Background"
                    >
                        {getFieldDecorator('ethnic_background', {
                            initialValue: (personethnicity && personethnicity.attributeVal && this.state.ethnic == '') ? personethnicity.attributeVal : this.state.ethnic,
                            rules: [{ required: true, message: 'Enter your Ethnic Background!' }],
                        })(
                            <Select style={{ width: '100%' }} onChange={this.changeEthinicity.bind(this)} >
                                {this.ethnicities()}
                            </Select>
                        )}
                    </FormItem>
                </Col>
            </Row>
        }

        return <Row>
                <Col span={24}>
                    <Spin indicator={LoadingIcon} className="loading-state" tip="Loading Personal Information..." />
                </Col>
            </Row>
    }

    renderLevels = () => {
        if (this.props.productprice_loading) {
            return <Row>
                <Col span={24}>
                    <Spin indicator={LoadingIcon} className="loading-state" tip="Loading SAF levels..." />
                </Col>
            </Row>
        }
        if (this.props.saflevels && this.props.productprice) {
            let saflevels = this.props.saflevels
            let productprice = this.props.productprice
            let price = 0
            let ArraySorting = []
            saflevels.map((k, index) => {
                let productname = (k.name).replace(/-/g, " ")
                productprice.map((j, index) => {
                    if (k.name == j.feeStructureCode) {
                        price = j.termFee
                        ArraySorting.push({ id: k.id, productname: k.name, price: j.termFee });
                    }
                })
            })
            ArraySorting = ArraySorting.sort((a, b) => a.price - b.price);
            return ArraySorting.map((k, index) => {
                return <Radio className='membership-radio' value={k.id} price={k.price} membership={k.productname}>
                    <span className="membership-level">{k.productname}</span>
                    <span className="membership-price">${k.price}.00</span>
                </Radio>
            })
        }
    }

    isEditMode = (editmode) => {
        if (editmode) {
            this.setState({
                hideNext: false
            })
        } else {
            this.setState({
                hideNext: true
            })
        }
    }

    renderPaymentButton = () => {

        if (this.props.response && !BackBtn) {
            this.next()
        }
        if (this.props.loading) {
            return <FormItem> <Button type="primary" className='submit-btn' loading > Loading ...</Button></FormItem>
        } else {
            if (this.state.showpaymentButton) {
                return <FormItem> <Button type="primary" className='submit-btn' onClick={() => this.payment()} > {this.state.SelectedMembershipPrice == 0 ? " RECEIPT" : " PAYMENT"}</Button> </FormItem>
            }
        }
    }

    componentDidMount = () => {
        const loggedinUser = JSON.parse(localStorage.getItem('user'))
        let personGUID = loggedinUser.personGuid;
        this.props.actions.getProfileInfo(personGUID)
        this.props.actions.getEthnicities()
        this.props.actions.getSAFmembershiplevels()
        this.props.actions.getProductPrice()
    }

    componentDidUpdate(prevProps) {
            if (!prevProps.regError && this.props.regError) {
                this.setState({ receipt_loading: false });
        
                const { errorCode, message, errorDesc } = this.props.regError;
        
                Modal.error({
                    title: `Error ${errorCode || ""}`,
                    content: (
                        <div>
                            <p><b>{message || "Request failed"}</b></p>
                            {errorDesc && <p>{errorDesc}</p>}
                        </div>
                    )
                });
            }
        }

    render() {
        const { current } = this.state;
        const { getFieldDecorator } = this.props.form;
        return (
            <div>
                <SAFHeader />

                <div className='step-widget'>
                    <div className='step-container'>
                        <div className='step-background'>
                            <Row type="flex" align="center" justify="center">
                                <Steps current={current}>
                                    <Step key="registration-info" title="Registration Info" />
                                    <Step key="level" title="Supporter Type" />
                                    <Step key="payment" title="Payment" />
                                    <Step key="receipt" title="Receipt" />
                                </Steps>
                            </Row>
                        </div>

                        <div className="steps-content centered">
                            {this.state.current == 0 &&
                                <div className="centered steps-form">

                                    <Row type="flex" justify="center" align="center">
                                        <Col span={24} className="center">
                                            <img src="../saflogo.png" className='SAF-logo' />
                                        </Col>
                                        <Col span={24} className="center">
                                            <span className='welcome-text'> WELCOME </span>
                                        </Col>
                                        <Col span={24} className="center">
                                            <span className='thank-you'>Thank you for your interest in supporting Scouting Alumni & Friends</span>
                                        </Col>

                                        <Col className="card-margin" span={24}>
                                            <Card
                                                className="centered"
                                                title="Personal Information"
                                            >
                                                {this.personalInfo()}
                                            </Card>
                                        </Col>

                                        <Col className="card-margin" span={24}>
                                            <MembershipAlumniInfo isEditMode={this.isEditMode.bind(this)} />
                                        </Col>

                                    </Row>
                                    <div className="steps-action centered" >
                                        <Row type="flex">
                                            <Col className='xs-center sm-center' xs={24} sm={24} md={12} lg={24} xl={24}>
                                                <Form onSubmit={this.handleSubmit} className="purchase-form">
                                                    <div className="steps-action centered">
                                                        {this.state.hideNext && <FormItem>
                                                            <Button type="primary" className='submit-btn' htmlType='submit' >NEXT</Button>
                                                        </FormItem>
                                                        }
                                                    </div>
                                                </Form>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            }
                            {this.state.current == 1 &&
                                <div className="centered steps-form">

                                    <Row type="flex" justify="center" align="center">
                                        <Col className="card-margin" span={24}>
                                            <Card
                                                className="centered membership-level-card"
                                                title="Supporter Types"
                                                extra="Standard Shipping 6-8 weeks"
                                            >
                                                <Row gutter={48}>
                                                    <Col span={24}>
                                                        <div className='membership-level'>
                                                            <RadioGroup onChange={this.ChangeAmount} value={this.state.SelectedMembership}>
                                                                {this.renderLevels()}
                                                            </RadioGroup>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Card>
                                        </Col>
                                    </Row>

                                    <div className="steps-action centered">
                                        <div>
                                            <Row type="flex" justify="space-between" align="center">
                                                <Col className='xs-center sm-center' xs={24} sm={24} md={12} lg={12} xl={12}>
                                                    <FormItem>
                                                        <Button type="primary" className='back-btn' onClick={() => this.prev()}>Back to Step 1</Button>
                                                    </FormItem>
                                                </Col>
                                                <Col className='xs-center sm-center' xs={24} sm={24} md={12} lg={12} xl={12}>
                                                    {this.renderPaymentButton()}
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>

                                </div>
                            }
                            {this.state.current == 2 &&
                                <div>
                                    <div className="centered steps-payment" >
                                        <Row className='margin-top-30' gutter={48} type="flex" justify="space-between" align="center">
                                            <Col xs={24} sm={24} md={24} lg={8} className="">
                                                <Card
                                                    className=""
                                                >
                                                    <Row type="flex" justify="space-between" align="center">
                                                        <Col span={12}>
                                                            <span className="title-txt">Total</span>
                                                        </Col>
                                                        <Col span={12}>
                                                            <span className="price-txt">${this.state.TotalAmount}.00</span>
                                                        </Col>
                                                    </Row>
                                                </Card>
                                            </Col>
                                            <Col xs={24} sm={24} md={24} lg={16} className="">
                                                <Card
                                                    className=""
                                                >
                                                    <Row type="flex" justify="space-between" align="center">
                                                        <Col span={12}>
                                                            <span className="title-txt">SAF Info</span> <br />
                                                            <span className="label-txt">{this.state.FirstName} {this.state.LastName}</span>
                                                        </Col>
                                                        <Col span={12} className="right">
                                                            <span className="verified"><Icon type="check-circle" /> Verified</span>
                                                        </Col>
                                                    </Row>
                                                    <hr />
                                                    <Row type="flex" justify="space-between" align="center">
                                                        <Col span={24}>
                                                            <span className="title-txt">Level</span>
                                                        </Col>

                                                        <Col span={18}>
                                                            <span className="label-txt">{this.state.SelectedMembershipName}</span>
                                                        </Col>
                                                        <Col span={6} className="right">
                                                            <span className="summary-price">${this.state.SelectedMembershipPrice}.00</span>
                                                        </Col>
                                                        {this.state.RushShipping == true &&
                                                            <Col span={24}>
                                                                <Col span={18}>
                                                                    <span className="label-txt">Rush Shipping and Handling 3-4 Business Days</span>
                                                                </Col>
                                                                <Col span={6} className="right">
                                                                    <span className="summary-price">$40.00</span>
                                                                </Col>
                                                            </Col>
                                                        }
                                                    </Row>
                                                </Card>
                                                <Card
                                                    className="margin-top-30"
                                                    title="Payment Information"

                                                >
                                                    <Row>
                                                        <Col span={10}>
                                                            <div className="checkbox-card-icon-wrapper">
                                                                <div>
                                                                    <span className="title-txt">Credit Card</span>
                                                                    <img src='../credit-card.png' className='credit-card-img' />
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <Spin tip="Please do not close the browser until the Receipt is displayed!" spinning={this.state.receipt_loading}>
                                                    {this.renderIframe()}
                                                    </Spin>
                                                </Card>
                                            </Col>

                                            <Col className='xs-center sm-center' xs={24} sm={24} md={12} lg={12} xl={12}>
                                                <Button type="primary" className='back-btn' onClick={() => this.prev()}>Back to Step 2</Button>
                                            </Col>
                                        </Row>
                                    </div>

                                </div>
                            }
                            {this.state.current == 3 &&
                                <div>
                                    <div className="centered steps-receipt" >
                                        <Row gutter={48} type="flex">
                                            <Col xs={24} sm={24} md={8} lg={8} className="margin-top-30">
                                                <Card
                                                    className=""
                                                >
                                                    <Row type="flex" justify="space-between" align="center">
                                                        <Col span={24}>
                                                            <span className="title-txt">Summary</span>
                                                        </Col>
                                                        <Col span={24} className='summary-block'>
                                                            <span className="label-high-txt">Name</span>
                                                            <span className="label-txt">{this.state.FirstName} {this.state.LastName}</span>
                                                        </Col>
                                                        <Col span={24} className='summary-block'>
                                                            <span className="label-high-txt">Date</span>
                                                            <span className="label-txt">{moment().format('MM/DD/YYYY')}</span>
                                                        </Col>
                                                        <Col span={24} className='summary-block'>
                                                            <span className="label-high-txt">Address</span>
                                                            <span className="label-txt">
                                                                {this.state.Address &&
                                                                    <span>
                                                                        {this.state.Address.address1}  <br />
                                                                        {this.state.Address.address2}  <br />
                                                                        {this.state.Address.city}  <br />
                                                                        {this.state.Address.zipCode}  <br />
                                                                    </span>
                                                                }
                                                            </span>
                                                        </Col>
                                                    </Row>
                                                    <hr />
                                                    <Row>
                                                        <Col span={24} className='summary-block'>
                                                            <span className="label-txt"><b>{this.state.SelectedMembershipName}</b></span>
                                                        </Col>
                                                        <Col span={12} className=''>
                                                            <span className="title-txt">Total</span>
                                                        </Col>
                                                        <Col span={12} className='right'>
                                                            <span className="summary-price"><b>${this.state.TotalAmount}.00</b></span>
                                                        </Col>
                                                    </Row>
                                                </Card>
                                            </Col>
                                            <Col xs={24} sm={24} md={14} lg={14} className="margin-top-30">
                                                <Card
                                                    className="receipt-header"
                                                    title="Scouting Alumni & Friends"
                                                >
                                                    <Row type="flex" justify="space-between" align="center">
                                                        <Col span={24} className='right'>
                                                            <img src="../saflogo.png" className='receipt-logo' />
                                                        </Col>
                                                        <Col>
                                                            <p> Welcome to Scouting Alumni & Friends!  We are delighted you have chosen to support Scouting, and we hope to have you involved for many years. </p>

                                                            <p> If you registered at the Pathfinder, Climber or Trailblazer level, you will receive a packet of branded items as well as instructions on how to access your perks in the mail soon. </p>

                                                            <p> You can help spread the word about Scouting Alumni & Friends by proudly displaying and using your affiliate items. In fact, go to www.bsaalumnistore.org and check out some of our "Scout Spirit" wear and use your one time discount code ALUMNI to receive a one time 10% discount at our Scouting Alumni & Friends Trading Post. </p>

                                                            <p> Thank you again for your support. We are proud to count you among our 50 million living alumni. It's good to have you involved! </p>

                                                            <p> And remember...</p>

                                                            <p> Once A Scout...Always A Scout, </p>
                                                        </Col>
                                                        <Col span={24} className="right signature-block">
                                                            <span>Yours in Scouting</span>
                                                            <img src='../dustinssignature.jpg' className='director-logo' />
                                                            <span><b>Dustin Farris</b></span>
                                                            <span>Director, Scouting Alumni & Friends</span>
                                                        </Col>
                                                    </Row>
                                                </Card>
                                            </Col>
                                            <Col xs={24} sm={24} md={14} lg={14}>
                                                <Button type="primary" className='submit-btn' onClick={() => window.location.assign('https://scoutingalumni.org/')}>GO HOME</Button>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <SAFFooter />
            </div >
        );
    }
}

function mapStateToProps(state) {
    return {
        loggingIn: state.authenticationReducer.loggingIn,
        timeout: state.authenticationReducer.timeout,
        initloading: state.chasepaymentreducer.loading,
        initTransaction: state.chasepaymentreducer.initTransaction,
        ethnicities_loading: state.ethnicitiesreducer.loading,
        ethnicities: state.ethnicitiesreducer.ethnicities,
        profileloading: state.profilereducer.loading,
        profileinfo: state.profilereducer.profileinfo,
        paymentstatus: state.paymentcompletedreducer.status,
        saflevels_loading: state.saflevelsreducer.loading,
        saflevels: state.saflevelsreducer.levels,
        productprice: state.productpricereducer.productprice,
        productprice_loading: state.productpricereducer.loading,
        loading: state.safmembershipreducer.loading,
        response: state.safmembershipreducer.response
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(actions, dispatch) }
}

const SAFSupport = Form.create()(SAFSupportForm);

export default connect(mapStateToProps, mapDispatchToProps)(SAFSupport);


// WEBPACK FOOTER //
// ./src/components/SAFSupport/index.js